import gql from 'graphql-tag';

/**
 * Query to get project info for a list of runs by their IDs.
 * Used when exporting/sharing workspace panels to reports,
 * to map cross-project pinned runs into separate run sets.
 * Can be removed once pinned runs are supported in reports.
 */
export const PINNED_RUNS_PROJECT_LOOKUP = gql`
  query PinnedRunsProjectLookup($pinnedRunIds: [ID!]!, $order: String!) {
    pinnedRuns: runs(ids: $pinnedRunIds, order: $order) {
      runs {
        id
        name
        project {
          id
          internalId
          name
          entityName
        }
      }
    }
  }
`;
